import styled from 'styled-components';

export const AnimationSectionStyle = styled.div`
  .amondz-form {
    .ant-form-item-label {
      width: 200px;
    }
  }

  .bae-form {
    margin-top: 20px;
  }

  .amondz-form-sub-content {
    padding-left: 200px;
    color: #6200ea;
    font-size: 13px;
    font-weight: 600;
  }
`;
